import { ActiveDiamond } from '@features/task-picker/components/ActiveDiamond'
import { Checkbox } from 'components/form/checkbox'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  checked: boolean
  variant: 'active' | 'inactive'
}

export const FilterMenuItem: FC<Props> = ({ checked, variant }) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-row text-sm items-center space-x-3">
      <Checkbox checked={checked} readOnly />
      <ActiveDiamond active={variant === 'active'} size="md" />
      <span>{t(`features.taskPicker.${variant}Tasks`)}</span>
    </div>
  )
}
